import { VChip } from 'vuetify/lib/components/VChip';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VLayout,{attrs:{"align-center":""}},[(_vm.rowData.vip == 'VIP')?_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VChip,_vm._g({attrs:{"color":"#ffd700","small":"","light":""}},on),[_vm._v("VIP")])]}}],null,false,2167491326)},[_c('span',[_vm._v(_vm._s(_vm.vipNote))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }